import {
    SAVE_ISAUTHENTICATED
  } from '../Constants/Type';
  
  export const saveIsAuthenticated = bool => ({
    type: SAVE_ISAUTHENTICATED,
    payload: bool
  });
  